
import { useState } from 'react';

import abdulHameedImg from '../assets/images/testimonials/testimonial-2.png';
import lokeshImg from '../assets/images/testimonials/testimonial-3.png';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import testimonialsData from '../assets/static_datas/testimonials.json';

// Map image filenames to imported images
const imageMap = {
    'testimonial-2.png': abdulHameedImg,
    'testimonial-3.png': lokeshImg,
};

// Process testimonials data to include proper image paths
const testimonialsObj = testimonialsData.map(testimonial => ({
    ...testimonial,
    testimonialImg: testimonial.testimonialImg
        ? (imageMap[testimonial.testimonialImg] || '')
        : ''
}));


const faqObj = [
    {
        faqID: "01",
        question: "What services does Sathish Design Studio provide?",
        answer: "Architectural services encompass the planning, design, and management of building projects from concept to completion. These services combine creativity, technical expertise, and functionality to create spaces that are aesthetically pleasing, safe, and sustainable.",

    },
    {
        faqID: "02",
        question: "What services does Sathish Design Studio provide?",
        answer: "Our team consists of experienced architects, BIM specialists, CAD technicians, and construction documentation experts. We have years of combined experience in the construction and design industry, working on projects of various scales and complexities.",

    },
    {
        faqID: "03",
        question: "What services does Sathish Design Studio provide?",
        answer: "Our construction and design services cover a wide range of project types including residential, commercial, and industrial buildings. We work with architects, engineers, contractors, and property owners to deliver comprehensive documentation and design solutions.",

    },
    {
        faqID: "04",
        question: "What services does Sathish Design Studio provide?",
        answer: "Yes, we work with clients both locally and remotely. Our team can handle projects through on-site visits when needed, or work entirely remotely using advanced collaboration tools and cloud-based platforms for seamless communication and project delivery.",

    },
    {
        faqID: "05",
        question: "What services does Sathish Design Studio provide?",
        answer: "We use industry-standard software including AutoCAD, Revit, BIM 360, SketchUp, 3ds Max, and other specialized construction and design tools. Our team stays updated with the latest technology and software to ensure the highest quality deliverables.",

    },
    {
        faqID: "06",
        question: "What services does Sathish Design Studio provide?",
        answer: "Our typical project timeline varies based on scope and complexity. Simple documentation projects may take 1-2 weeks, while comprehensive BIM modeling and design projects can take several months. We provide detailed timelines during the initial consultation and keep clients updated throughout the project.",
    },

];


const chooseSDS = [
    {
        id: "1",
        icon: "fa-solid fa-chart-line", // Live project tracking - chart line works well
        title: "Live project tracking portal",
        description: "Track your interior project 24/7 with real-time updates on work progress, manufacturing, installations, materials, QC, and payments — perfect for full transparency, especially for NRI clients.",
    },
    {
        id: "2",
        icon: "fa-solid fa-file-circle-check", // Online approval system - file with check
        title: "Online approval system",
        description: "Chennai’s first single-window online approval system — we handle applications, documents, drawings, FSI checks, corrections, and final sanction follow-up so homeowners never need to visit any office.",
    },
    {
        id: "3",
        icon: "fa-solid fa-vr-cardboard", // VR/AR decision-making
        title: "VR/AR decision-making",
        description: "Traditional 2D drawings and screenshots can mislead proportions, hide structural limits, and fail to show the true feel of a space. With VR, you walk through your home before it’s built — preventing costly mistakes and last-minute changes.",
    },
    {
        id: "4",
        icon: "fa-solid fa-cogs", // Structural + MEP under one roof - engineering/complex systems
        title: "Structural + MEP under one roof",
        description: "Complete MEP design covering electrical, plumbing, HVAC, and shaft routing — ensuring leak-proof plumbing, balanced electrical loads, and efficient AC planning.",
    },
    {
        id: "5",
        icon: "fa-solid fa-ruler-combined", // Laser scanned accuracy - measurement
        title: "Laser scanned accuracy",
        description: "Millimeter-accurate 3D laser scanning and as-built surveys for renovation, extensions, approvals, and design. We capture true site dimensions and convert them into precise CAD/BIM models — eliminating errors caused by manual measurements.",
    },
    {
        id: "6",
        icon: "fa-solid fa-money-bill-wave", // Transparent pricing - money / billing
        title: "Transparent pricing",
        description: "Most agents add extra charges for corrections, additional sheets, inspections, and rule updates. We offer a transparent rate card with zero hidden fees.",
    },
     {
        id: "7",
        icon: "fa-solid fa-calendar-week", // Weekly site updates
        title: "Weekly site updates",
        description: "Complete CMDA/DTCP approval support including plan approvals, regularisation, floor additions, land-use changes, patta, NOCs, layout approval, and completion certificate assistance.",
    },
     {
        id: "8",
        icon: "fa-solid fa-city", // Chennai-wide approval expertise
        title: "Chennai-wide approval expertise",
        description: "End-to-end approval expertise across Chennai, with deep knowledge of local rules, zones, and compliance requirements.",
    },
]


const homeCounterValue = [
    {
        id: 1,
        value: 500,
        title: "Happy Clients"
    },
    {
        id: 2,
        value: 600,
        title: "Projects Done"
    },
    {
        id: 3,
        value: 15,
        title: "Designers"
    },
    {
        id: 4,
        value: 20,
        title: "Years of Experiance"
    }
];

const upComingBatchesCounter = [
    {
        id: 1,
        value: 10,
        title: "Active Projects"
    },
    {
        id: 2,
        value: 50,
        title: "Projects Completed"
    },
    {
        id: 3,
        value: 100,
        title: "Client Consultations"
    },
    {
        id: 4,
        value: 20,
        title: "Expert Team Members"
    }

];

const sdsWorkCounter = [
    {
        id: 1,
        value: 10,
        title: "Industry-Leading Partnerships"
    },
    {
        id: 2,
        value: 50,
        title: "Innovative Projects Completed"
    },
    {
        id: 3,
        value: 100,
        title: "Alumni Making Their Mark"
    },
    {
        id: 4,
        value: 20,
        title: "ECutting-Edge Tools and Resources"
    }

];

const homeHeadingDetails = {
    title: "Our Blogs",
    description: "Explore insights, tutorials, and case studies in architecture, BIM, construction, and more."
}


const useCustom = () => {
    const [show, setShow] = useState(false);
    const [testimonials, setTestimonials] = useState(testimonialsObj);
    const [faq, setFaq] = useState(faqObj);
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [individualBlog, setIndividualBlog] = useState({});
    const [whyChoose] = useState(chooseSDS);

    const [servicesData, setServicesData] = useState([]);
    const [servicesLoading, setServicesLoading] = useState(true);

    // Default icons for sub-services (fallback when API doesn't provide icon)
    const defaultIcons = [
        "fa-solid fa-border-all",
        "fa-solid fa-house-circle-check",
        "fa-solid fa-warehouse",
        "fa-solid fa-solar-panel",
        "fa-solid fa-magnifying-glass",
        "fa-solid fa-drafting-compass",
        "fa-solid fa-layer-group",
        "fa-solid fa-vr-cardboard",
        "fa-solid fa-calculator"
    ];


    const [syllabus, setSyllabus] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = (isSyllabus) => {
        if (isSyllabus === 'syllabus') {
            setSyllabus(true);
        } else {
            setSyllabus(false);
        }
        setShow(true);
    }

    const bookMySeat = () => {
        document.getElementById("contactUs").scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    };

    function formatDate(dateString) {
        const date = new Date(dateString);

        const day = date.getDate();
        const month = date.toLocaleString("en-US", { month: "long" });
        const year = date.getFullYear();

        // Get ordinal (1st, 2nd, 3rd, 4th...)
        const ordinal = (n) => {
            if (n > 3 && n < 21) return n + "th";
            switch (n % 10) {
                case 1: return n + "st";
                case 2: return n + "nd";
                case 3: return n + "rd";
                default: return n + "th";
            }
        };

        let hours = date.getHours();
        let minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";

        // Convert to 12-hour format
        hours = hours % 12 || 12;

        return `${ordinal(day)} ${month} ${year}, ${hours}.${minutes} ${ampm}`;
    }


    const fetchBlogs = async (search, count = 'all') => {
        setLoading(true);
        const queryParams = `${count === 'all' ? '' : 'per_page=' + count}&search=${search}`;
        axios.get(`${getApiUrl('api/public/blogs')}?${queryParams}`)
            .then(function (response) {
                // handle success
                setLoading(false);
                // Safely extract blogs data with fallback
                const blogsData = response?.data?.data?.data || response?.data?.data || [];
                setBlogs(Array.isArray(blogsData) ? blogsData : []);
            })
            .catch(function (error) {
                // handle error
                setLoading(false);
                // Set blogs to empty array on error to prevent undefined issues
                setBlogs([]);
            });

    }


    const fetchIndividualBlog = async (blogslug) => {
        setLoading(true);
        axios.get(getApiUrl(`api/public/blogs/${blogslug}`))
            .then(function (response) {
                // handle success
                setLoading(false);
                setIndividualBlog(response.data.data);
            })
            .catch(function (error) {
                // handle error
                setLoading(false);
            });

    }

    const fetchServices = async () => {
        try {
            setServicesLoading(true);
            const response = await axios.get(getApiUrl('api/public/services/all-with-children'));

            if (response.data.success && response.data.data) {
                // Map API response to match component's expected structure
                const mappedServices = response.data.data.map((service, serviceIndex) => ({
                    id: service.id,
                    text: service.title,
                    icon: service.icon,
                    excerpt: service.excerpt,
                    slug: service.slug,
                    sub_services: service.sub_services?.map((subService, subIndex) => ({
                        id: subService.id,
                        text: subService.title,
                        slug: subService.slug,
                        description: subService.excerpt || '',
                        // Use default icon based on index, or you can add icon mapping logic here
                        icon: defaultIcons[subIndex % defaultIcons.length]
                    })) || []
                }));

                setServicesData(mappedServices);
            } else {
                setServicesData([]);
            }
        } catch (error) {
            console.error('Error fetching services:', error);
            setServicesData([]);
        } finally {
            setServicesLoading(false);
        }
    };

    return {
        show,
        setShow,
        handleClose,
        handleShow,
        syllabus,
        testimonials,
        faq,
        homeCounterValue,
        upComingBatchesCounter,
        sdsWorkCounter,
        homeHeadingDetails,
        setTestimonials,
        setFaq,
        bookMySeat,
        fetchBlogs,
        blogs,
        formatDate,
        fetchIndividualBlog,
        individualBlog,
        loading,
        whyChoose,
        fetchServices,
        servicesData,
        servicesLoading
    }
}

export default useCustom;